.registerAttribute {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  width: 45%;
}

@media (max-width: 767.98px) {
  .registerAttribute {
    width: 100%;
  }
}

.input {
  margin-top: 0.2rem;
}
